import React from 'react';
import { Hero } from '../components/Hero';
import { ValueProps } from '../components/ValueProps';
import { ProductCard } from '../components/ProductCard';
import { products } from '../utils/products';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function HomePage() {
  return <main className="bg-[#0f0f0f]" data-id="element-309">
      <Hero data-id="element-310" />
      <ValueProps data-id="element-311" />

      {/* Products Section */}
      <section id="products" className="py-24 bg-gradient-to-b from-[#0f0f0f] to-[#1a1a1a]" data-id="element-312">
        <div className="container mx-auto px-4" data-id="element-313">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-314">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-315">
              Professional Equipment
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-316">
              Choose the perfect sprayer for your needs. From complete units to
              DIY kits and replacement parts.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-317">
            {products.map((product, index) => <motion.div key={product.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} viewport={{
            once: true
          }} data-id="element-318">
                <ProductCard product={product} data-id="element-319" />
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Social Proof */}
      <section className="py-24 bg-[#0f0f0f]" data-id="element-320">
        <div className="container mx-auto px-4" data-id="element-321">
          <div className="max-w-4xl mx-auto" data-id="element-322">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-center mb-16" data-id="element-323">
              <div className="flex justify-center gap-1 mb-4" data-id="element-324">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-[#FFA500] text-[#FFA500]" data-id="element-325" />)}
              </div>
              <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-326">
                Trusted by Professionals
              </h2>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-327">
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border border-gray-800" data-id="element-328">
                <div className="flex gap-1 mb-4" data-id="element-329">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#FFA500] text-[#FFA500]" data-id="element-330" />)}
                </div>
                <p className="text-gray-300 text-lg mb-6 leading-relaxed" data-id="element-331">
                  "This sprayer has completely changed how we work. No more hand
                  pumping, consistent pressure all day. Best investment we've
                  made."
                </p>
                <div className="flex items-center gap-3" data-id="element-332">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#FF6B35] to-[#FFA500] flex items-center justify-center text-white font-bold" data-id="element-333">
                    DM
                  </div>
                  <div data-id="element-334">
                    <div className="text-white font-bold" data-id="element-335">David Martinez</div>
                    <div className="text-gray-500 text-sm" data-id="element-336">
                      Mold Remediation Specialist
                    </div>
                  </div>
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border border-gray-800" data-id="element-337">
                <div className="flex gap-1 mb-4" data-id="element-338">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#FFA500] text-[#FFA500]" data-id="element-339" />)}
                </div>
                <p className="text-gray-300 text-lg mb-6 leading-relaxed" data-id="element-340">
                  "The 40-foot hose is a game changer. I can reach entire attics
                  without moving the unit. Saves so much time and effort."
                </p>
                <div className="flex items-center gap-3" data-id="element-341">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#3B82F6] to-[#2563EB] flex items-center justify-center text-white font-bold" data-id="element-342">
                    SK
                  </div>
                  <div data-id="element-343">
                    <div className="text-white font-bold" data-id="element-344">Sarah Kim</div>
                    <div className="text-gray-500 text-sm" data-id="element-345">
                      Water Restoration Pro
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 bg-gradient-to-r from-[#FF6B35] to-[#FFA500]" data-id="element-346">
        <div className="container mx-auto px-4" data-id="element-347">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-348">
            {[{
            value: '7+',
            label: 'Years in Business'
          }, {
            value: '500+',
            label: 'Units Sold'
          }, {
            value: '5,000+',
            label: 'Gallons Sprayed'
          }, {
            value: '10,000+',
            label: 'Hours Saved'
          }].map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.5
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: index * 0.1
          }} viewport={{
            once: true
          }} data-id="element-349">
                <div className="text-4xl md:text-5xl font-black text-white mb-2" data-id="element-350">
                  {stat.value}
                </div>
                <div className="text-white/80 font-medium text-sm uppercase tracking-wider" data-id="element-351">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </main>;
}